export function focus(id?: string|null) {
    if(id) {
        // console.log(document.getElementById(id));
        document.getElementById(id)?.focus();
    }
}

export function get(key: string, href?: string): string | null {
    const params = new URL(href ?? window.location.href).searchParams;

    if(!params.has(key)) {
        return null;
    }

    return params.get(key);
}
export function isAbbreviation(value: string): boolean {
    return /^(\d+|[A-Z]{2,5})$/.test(value);
}

/**
 * Reduce a name to initials for an avatar bubble. Ported from courier's
 * helpers/string.ts, where MobilePhone.vue originated.
 */
export function abbreviate(value: string, maxLength?: number): string {
    if(isAbbreviation(value)) {
        return maxLength ? value.substring(0, maxLength) : value;
    }

    const words = value.split(' ')
        .map(value => value.replace(/[^\d\w\s]+/, ''))
        .filter(Boolean)
        .filter((value, index, array) => array.indexOf(value) === index);

    if(words.length > 1) {
        const result = words.map(word => {
            if(word.match(/^\d+$/)) {
                return word;
            }

            if(isAbbreviation(word)) {
                return word;
            }

            return word.substring(0, 1);
        }).join('').toUpperCase();

        return maxLength ? result.substring(0, maxLength) : result;
    }

    if(maxLength === 2 && value.length > 1) {
        return (value.substring(0, 1) + value.substring(value.length - 1)).toUpperCase();
    }

    return value.substring(0, maxLength || 3).toUpperCase();
}
